// axios
import axios from "axios";

//const domain = "https://api.al-dallal.net/";
const domain = "https://apidev.al-dallal.net/";
//const domain = "http://87.237.226.143:7777/";

//const domain = "https://localhost:7070/";


export default axios.create({
  baseURL: domain
  // You can add your headers here
});
